import React from 'react'
import { useLocation, Link } from 'react-router-dom';

const Footer = () => {
    const location = useLocation();
    const currentPath = location.pathname;

    const pages = [
        { name: "Home", path: '/' },
        { name: "Services", path: '/service' },
        { name: "About", path: '/about' },
        { name: "Contact", path: '/contact' },
    ]

    const isActive = (path) => currentPath === path;

    return (
        <>
            {/* Footer Section */}
            <footer className='w-full bg-gradient-to-t from-gray-800 to-black text-white/90 pt-10'>

                <div className='container mx-auto px-5 lg:px-28 flex flex-col md:flex-row gap-8 md:gap-6 lg:gap-12 pb-8'>
                    {/* Brand Section */}
                    <div className='space-y-5 md:w-1/4 lg:w-1/4'>
                        <div className=" font-poppins flex items-center gap-2">

                            <h1 className=" text-white text-lg md:text-base lg:text-xl font-medium tracking-widest">
                                <span className="text-yellow-400">&lt;</span>Geo<span className="text-yellow-400">/&gt;</span>Code
                            </h1>
                        </div>
                        <div>
                            <p className='text-sm md:text-xs lg:text-base'>Our mission is to partner with businesses to deliver innovative, tailored services that drive efficiency, growth, and long-term success across industries.</p>
                        </div>
                    </div>

                    {/* Quick Links */}
                    <div className='space-y-2 md:space-y-4 lg:space-y-5 md:w-1/5 lg:w-1/5'>
                        <h1 className='text-lg md:text-base lg:text-xl font-medium'>Quick Links</h1>
                        <ul className='space-y-2'>
                            {pages.map((page, index) => (
                                <li key={index}>
                                    <a
                                        href={page.path}
                                        className={`uppercase tracking-widest text-sm md:text-xs lg:text-sm font-medium transition-colors duration-150 hover:text-yellow-400 ${isActive(page.path)
                                            ? 'font-bold text-yellow-400'
                                            : 'text-gray-300'
                                            }`}
                                    >
                                        {page.name}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Contact Info */}
                    <div className='space-y-2 md:space-y-4 lg:space-y-5 md:w-1/4 lg:w-1/5'>
                        <h1 className='text-lg md:text-base lg:text-xl font-medium'>Contact Us</h1>
                        <ul className='space-y-2 text-gray-300'>
                            {/* WhatsApp / Phone */}
                            <li className='flex items-start'>
                                <a
                                    href="tel:+919025703761"
                                    className="flex items-start text-gray-300 hover:text-yellow-500 transition"
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="h-5 w-5 mr-2 mt-0.5 text-yellow-500 flex-shrink-0"
                                        viewBox="0 0 32 32"
                                        fill="currentColor"
                                    >
                                        <path d="M16.003 3C9.376 3 3.999 8.377 3.999 15.004c0 2.654.875 5.116 2.355 7.126L5 29l7.074-1.339a12.94 12.94 0 0 0 3.93.603c6.627 0 12.004-5.377 12.004-12.004S22.63 3 16.003 3zm0 21.89c-1.302 0-2.57-.34-3.692-.985l-.264-.156-4.198.794.804-4.097-.171-.27a8.976 8.976 0 0 1-1.384-4.772c0-4.962 4.043-9.005 9.005-9.005s9.005 4.043 9.005 9.005-4.043 9.005-9.005 9.005zm5.232-6.755c-.285-.143-1.695-.84-1.958-.934-.263-.095-.454-.143-.646.143-.192.285-.742.934-.91 1.126-.167.191-.335.215-.62.072-.285-.143-1.202-.443-2.29-1.414-.846-.754-1.418-1.687-1.585-1.972-.167-.285-.018-.439.126-.582.129-.128.285-.335.428-.503.143-.167.19-.287.286-.478.095-.191.048-.358-.024-.503-.72-.143-.646-1.559-.885-2.132-.23-.553-.465-.477-.646-.486l-.552-.01c-.191 0-.503.072-.767.358s-1.007.983-1.007 2.397 1.031 2.776 1.175 2.965c.143.191 2.03 3.098 4.925 4.344.688.297 1.223.475 1.64.61.688.219 1.314.188 1.81.114.552-.082 1.695-.693 1.934-1.364.239-.67.239-1.246.167-1.364-.071-.119-.262-.191-.547-.334z" />
                                    </svg>
                                    <span className='text-sm md:text-xs lg:text-base'>+91 9025703761</span>
                                </a>
                            </li>

                            {/* Email */}
                            <li className='flex items-start'>
  <a
    href="https://mail.google.com/mail/?view=cm&fs=1&to=geocodesoftsolution@gmail.com"
    target="_blank"
    rel="noopener noreferrer"
    className="flex items-start text-gray-300 hover:text-yellow-500 transition"
  >
    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2 mt-0.5 text-yellow-400 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
    </svg>
    <span className='text-sm md:text-xs lg:text-base'>geocodesoftsolution@gmail.com</span>
  </a>
</li>


                            {/* Address */}
                            <li className='flex items-start'>
                                <a
                                    href="https://www.google.com/maps/place/Kurumpanai,+Tamil+Nadu,+India"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="flex items-start text-gray-300 hover:text-yellow-500 transition"
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2 mt-0.5 text-yellow-400 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                                    </svg>
                                    <span className='text-sm md:text-xs lg:text-base'>Kurumpanai, Marthandam, India</span>
                                </a>
                            </li>
                        </ul>
                    </div>

                    {/* Social Media */}
                    <div className='space-y-3 md:space-y-4 lg:space-y-5 md:w-1/3 lg:w-1/5'>
                        <h1 className='text-lg md:text-base lg:text-xl font-medium'>Follow Us</h1>
                        <div className='flex gap-3 md:gap-2 lg:gap-4'>
                            <a href="https://www.instagram.com/geocode_softsolution/" target='_blank' className="text-gray-300 hover:text-yellow-400 transition-colors duration-200">
                                <span className="[&>svg]:h-6 [&>svg]:w-6 md:[&>svg]:h-5 md:[&>svg]:w-5 lg:[&>svg]:h-7 lg:[&>svg]:w-7">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="currentColor"
                                        viewBox="0 0 448 512">
                                        <path
                                            d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z" />
                                    </svg>
                                </span>
                            </a >
                            <a href="https://www.linkedin.com/company/geocodesoftsolution/" target='_blank' className="text-gray-300 hover:text-yellow-400 transition-colors duration-200">
                                <span className="[&>svg]:h-6 [&>svg]:w-6 md:[&>svg]:h-5 md:[&>svg]:w-5 lg:[&>svg]:h-7 lg:[&>svg]:w-7">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="currentColor"
                                        viewBox="0 0 448 512">
                                        <path
                                            d="M100.3 448H7.4V148.9h92.9zM53.8 108.1C24.1 108.1 0 83.5 0 53.8a53.8 53.8 0 0 1 107.6 0c0 29.7-24.1 54.3-53.8 54.3zM447.9 448h-92.7V302.4c0-34.7-.7-79.2-48.3-79.2-48.3 0-55.7 37.7-55.7 76.7V448h-92.8V148.9h89.1v40.8h1.3c12.4-23.5 42.7-48.3 87.9-48.3 94 0 111.3 61.9 111.3 142.3V448z" />
                                    </svg>
                                </span>
                            </a>
                            <a href="https://x.com/Geocode_India/" target='_blank' className="text-gray-300 hover:text-yellow-400 transition-colors duration-200">
                                <span className="[&>svg]:h-6 [&>svg]:w-6 md:[&>svg]:h-5 md:[&>svg]:w-5 lg:[&>svg]:h-7 lg:[&>svg]:w-7">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="currentColor"
                                        viewBox="0 0 512 512">
                                        <path
                                            d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z" />
                                    </svg>
                                </span>
                            </a>
                            <a href="https://www.facebook.com/share/1Z7P61Ep6n/" target="_blank" className="text-gray-300 hover:text-yellow-400 transition-colors duration-200">
                                <span className="[&>svg]:h-6 [&>svg]:w-6 md:[&>svg]:h-5 md:[&>svg]:w-5 lg:[&>svg]:h-7 lg:[&>svg]:w-7">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="currentColor"
                                        viewBox="0 0 320 512"
                                    >
                                        <path d="M279.14 288l14.22-92.66h-88.91V127.38c0-25.35 12.42-50.06 52.24-50.06H293V6.26S269.5 0 248.25 0c-73.22 0-121 44.38-121 124.72V195.3H56.89V288h70.36v224h86.46V288z" />
                                    </svg>
                                </span>
                            </a>
                        </div>

                        {/* Newsletter Subscription */}
                        <div className="mt-4 md:mt-3 lg:mt-4">
                            <h3 className="text-sm md:text-xs lg:text-sm font-medium mb-2">Subscribe to our newsletter</h3>
                            <div className="flex">
                                <input
                                    type="email"
                                    placeholder="Your email"
                                    className="px-3 py-2 bg-gray-700 text-white rounded-l-md focus:outline-none focus:ring-2 focus:ring-yellow-400 w-full text-sm md:text-xs lg:text-sm"
                                />
                                <button className="bg-yellow-400 hover:bg-yellow-500 text-gray-900 font-medium px-3 py-2 rounded-r-md text-sm md:text-xs lg:text-sm transition-colors duration-200 whitespace-nowrap">
                                    Subscribe
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Copyright Section */}
                <div className="bg-gray-900 text-center text-sm md:text-xs lg:text-sm text-gray-300 py-4 border-t border-gray-700">
                    <div className="container mx-auto px-5 lg:px-28">
                        © {new Date().getFullYear()}<span className="text-yellow-400">&lt;</span>Geo<span className="text-yellow-400">/&gt;</span>Code. All rights reserved.
                        <div className="mt-1 md:mt-1 lg:mt-1">
                            <a href="/privacy" className="text-gray-400 hover:text-yellow-400 mr-3 md:mr-2 lg:mr-4 text-xs md:text-xs lg:text-sm">Privacy Policy</a>
                            <a href="/terms" className="text-gray-400 hover:text-yellow-400 mr-3 md:mr-2 lg:mr-4 text-xs md:text-xs lg:text-sm">Terms of Service</a>
                            <a href="/cookie" className="text-gray-400 hover:text-yellow-400 text-xs md:text-xs lg:text-sm">Cookie Policy</a>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    )
}

export default Footer;